/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Cursor({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 16" {...props}><path fill="currentColor" d="M13.327 3.545c.223.144.48.275.611.517.07.316.038.643.043.964q-.005 3.128 0 6.253c-.004.214.004.432-.041.643-.135.208-.362.328-.565.457-1.749 1-3.49 2.015-5.233 3.024-.371.207-.726.456-1.13.597-.25-.036-.467-.179-.685-.294-1.767-1.041-3.553-2.048-5.321-3.087A6.7 6.7 0 0 1 0 11.95V4.034c.428-.422.985-.668 1.491-.98C3.252 2.035 5.01 1.005 6.78 0h.42c2.04 1.187 4.088 2.36 6.128 3.545m-11.205.687c-.497.017-.997-.038-1.494.019.26.254.598.39.91.566q.068.037.135.079C3.42 5.93 5.197 6.917 6.935 7.969c.09.505.05 1.02.055 1.53.002 1.748-.004 3.497 0 5.245q0 .148.013.294l.039.291c.13-.175.255-.356.361-.547 1.881-3.262 3.766-6.521 5.634-9.79.139-.229.245-.475.326-.73-.344-.027-.69-.033-1.034-.033s-.69.006-1.035.003a6287 6287 0 0 0-9.172 0" /></svg>;
}
;